import { render } from "./TriadUsersListComponent.vue?vue&type=template&id=428c4e53&scoped=true"
import script from "./TriadUsersListComponent.vue?vue&type=script&lang=js"
export * from "./TriadUsersListComponent.vue?vue&type=script&lang=js"

import "./TriadUsersListComponent.vue?vue&type=style&index=0&id=428c4e53&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-428c4e53"]])

export default __exports__